import { render } from "./yxDoubleBarChart.vue?vue&type=template&id=034a8772&scoped=true"
import script from "./yxDoubleBarChart.vue?vue&type=script&lang=js"
export * from "./yxDoubleBarChart.vue?vue&type=script&lang=js"

import "./yxDoubleBarChart.vue?vue&type=style&index=0&id=034a8772&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034a8772"]])

export default __exports__